import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Samples from './pages/Samples';
import Subscribers from './pages/Subscribers';
import EmailTracking from './pages/EmailTracking';
import EmailTemplate from './pages/EmailTemplate';
import CustomEmails from './pages/CustomEmails';
import PreviewPage from './pages/PreviewPage';
import SignupPage from './pages/SignupPage';
import PreSavePage from './pages/PreSavePage';
import EAPreSavePage from './pages/EAPreSavePage';
import AdventCalendar from './pages/AdventCalendar';
import Layout from './components/Layout';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/preview" element={<PreviewPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/pre-save" element={<PreSavePage />} />
        <Route path="/ea-presave" element={<EAPreSavePage />} />
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/" /> : <Login onLogin={handleLogin} />
          } 
        />
        
        {/* Protected admin routes */}
        {isAuthenticated ? (
          <>
            <Route path="/" element={
              <Layout onLogout={handleLogout}>
                <Dashboard />
              </Layout>
            } />
            <Route path="/samples" element={
              <Layout onLogout={handleLogout}>
                <Samples />
              </Layout>
            } />
            <Route path="/subscribers" element={
              <Layout onLogout={handleLogout}>
                <Subscribers />
              </Layout>
            } />
            <Route path="/tracking" element={
              <Layout onLogout={handleLogout}>
                <EmailTracking />
              </Layout>
            } />
            <Route path="/custom-emails" element={
              <Layout onLogout={handleLogout}>
                <CustomEmails />
              </Layout>
            } />
            <Route path="/template" element={
              <Layout onLogout={handleLogout}>
                <EmailTemplate />
              </Layout>
            } />
            <Route path="/advent-calendar" element={
              <Layout onLogout={handleLogout}>
                <AdventCalendar />
              </Layout>
            } />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;

